/* eslint-disable camelcase */
export default {
  unknown_error: "Unexpected error fetching transaction log!",
};
